$(window).ready(function(){
  
  
  // $(".template-collection .header-cart").click(function(){
  //   window.location.href = $(this).attr('href');
  // });
  
  
  // Mobile search
  
  $(document).on('click','.boost-pfs-search-btn-close-suggestion',function(){
    $("body").removeClass('showOverly');
    $("#searchPopup").removeClass('active');
  });
  
  
});